<footer class="footer">
  <div class="row justify-content-center text-center my-auto">
    <div class="col-auto mx-auto">
      <small> Interticket © 2024 </small>
    </div>
  </div>
</footer>
